import { type AxiosResponse } from 'axios'
import { baseApi } from 'entities/Auth'
import {
  type IParamsPostChats,
  type IParamsUpdateUserSettings,
  type IResponseOrganizationSettings,
  type IResponseUpdateUserSettings,
  type IResponseUserSettings,
  type IResponseWebsiteChatWidgetSettings,
} from 'entities/Settings/api/types'

class Api {
  getUsersSettings(): Promise<AxiosResponse<IResponseUserSettings>> {
    return baseApi.get('users/settings')
  }

  getOrganizationSettings(): Promise<AxiosResponse<IResponseOrganizationSettings>> {
    return baseApi.get('organization/settings')
  }

  updateUsersSetting(
    params: IParamsUpdateUserSettings
  ): Promise<AxiosResponse<IResponseUpdateUserSettings>> {
    return baseApi.patch('users/settings', params)
  }

  getWebsiteChatWidgetSettings(): Promise<AxiosResponse<IResponseWebsiteChatWidgetSettings>> {
    return baseApi.get('chats')
  }

  updateChatsStatus(status: boolean): Promise<AxiosResponse<IResponseWebsiteChatWidgetSettings>> {
    return baseApi.post('chats/status', { status })
  }

  postChats(payload: IParamsPostChats): Promise<AxiosResponse<IResponseWebsiteChatWidgetSettings>> {
    return baseApi.post('chats', payload)
  }
}

export const SettingsApi = new Api()
